import VaultBaseController from '../common/vault.base.controller'

class VaultEditController extends VaultBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, VaultService, Modal, $translate, $stateParams) {
		super(Auth, $state, User, VaultService, Modal, $translate, $stateParams)

		this.model.id = ''
		this.model.description = ''
	}

	$onInit() {
		this.Service.get(this.$stateParams.id)
			.then((data) => {
				this.rawId = data.id
				this.model.id = data.id
				this.model.description = data.description
			})
	}

	reset() {
		this.model.description = ''
		this.clearErrors()
	}

	submit(evt) {
		if (!this.validate()) {
			return
		}

		this.loading = true
		this.Service.update(this.rawId, {
				id: this.model.id,
				description: this.model.description
			})
			.then((data) => {
				this.loading = false
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
			})
	}
}

export default VaultEditController;


// WEBPACK FOOTER //
// ./client/app/components/vault/edit/vault.edit.controller.js